var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, DialogTitle, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-regular-svg-icons/faClose";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import { combineSxProps } from "../../Utils";
export const TruffleDialogTitle = (props) => {
    const { CloseIconButtonProps, HelpCenterIconButtonProps, children, sx: sxProp } = props, dialogTitleProps = __rest(props, ["CloseIconButtonProps", "HelpCenterIconButtonProps", "children", "sx"]);
    return _jsxs(DialogTitle, Object.assign({ sx: combineSxProps({ justifyContent: children ? "space-between" : "flex-end" }, sxProp) }, dialogTitleProps, { children: [children, CloseIconButtonProps || HelpCenterIconButtonProps
                ? _jsxs(Box, { sx: { flexShrink: 0 }, children: [HelpCenterIconButtonProps
                            ? _jsx(IconButton, Object.assign({}, HelpCenterIconButtonProps, { children: _jsx(FontAwesomeIcon, { icon: faCircleQuestion }) }))
                            : null, CloseIconButtonProps
                            ? _jsx(IconButton, Object.assign({}, CloseIconButtonProps, { children: _jsx(FontAwesomeIcon, { icon: faClose }) }))
                            : null] })
                : null] }));
};
//# sourceMappingURL=TruffleDialogTitle.js.map